// extracted by mini-css-extract-plugin
export default {"modal":"Modal_modal__FVTXn","modalDialog":"Modal_modalDialog__B+iA5","md":"Modal_md__taPko","sm":"Modal_sm__6Sirl"};